import React from 'react';

export interface ProgressBarProps {
  value: number; // 0..100
  label?: string;
  className?: string;
  // novos: permitem customizar as cores/estilos sem alterar o componente no restante do app
  trackClassName?: string;
  indicatorClassName?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  label,
  className,
  trackClassName,
  indicatorClassName,
}) => {
  const clamped = Math.max(0, Math.min(100, value ?? 0));

  return (
    <div className={className}>
      {label ? <div className="mb-1 text-sm text-gray-700">{label}</div> : null}
      <div className={trackClassName ?? 'w-full bg-gray-200 rounded h-2 overflow-hidden'}>
        <div
          className={indicatorClassName ?? 'bg-blue-600 h-2 transition-all duration-200'}
          style={{ width: `${clamped}%` }}
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
          role="progressbar"
        />
      </div>
    </div>
  );
};